module.exports = __webpack_public_path__ + "static/media/icon-borderedGreen.9ce69084.svg";